// extracted by mini-css-extract-plugin
module.exports = {"component":"main-navigation_component__OnqSF","isMenuOpen":"main-navigation_isMenuOpen__bDxQj"};